var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.location}},[_vm._v("\n  участник скачек\n")])}
var staticRenderFns = []

export { render, staticRenderFns }